import React from 'react';
import {View, StyleSheet, StyleProp, TextStyle, ViewStyle} from 'react-native';
import {TextInput} from 'react-native-paper';
import Styles from 'src/components/Styles';
import QRIconSVG from '../../img/svg/QRIconSVG';
import Localized from 'src/constants/AppStrings';
import AVText from 'src/components/elements/AVText';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

type DiscountCodeInputProps = {
  value: string;
  onChangeText: (t: string) => void;
  onScanQr: () => void;
  onApply: () => void;
  showError?: boolean;
  errorMsg?: string;
  label?: string;
  errorTextStyle?: StyleProp<TextStyle>;
  outlineStyle?: StyleProp<ViewStyle>;
  activeColor?: string;
};

const DiscountCodeInput: React.FC<DiscountCodeInputProps> = ({
  value,
  onChangeText,
  onScanQr,
  onApply,
  showError = false,
  errorMsg,
  label = 'Discount code',
  errorTextStyle,
  outlineStyle,
  activeColor,
}) => (
  <View style={styles.container}>
    {/* input + icons */}
    <View style={styles.inputWrapper}>
      <TextInput
        mode="outlined"
        label={label}
        value={value}
        onChangeText={onChangeText}
        outlineStyle={[styles.outlineStyle, styles.shadowStyle, outlineStyle]}
        contentStyle={styles.contentStyle}
        style={styles.input}
        placeholderTextColor={Styles.Colors.PayNew.darkHuesBase04}
        activeOutlineColor={
          activeColor ? activeColor : Styles.Colors.PayNew.darkHuesBase04
        }
        accessible
        testID="qa_Checkout.DiscountCode_fld"
        nativeID="qa_Checkout.DiscountCode_fld"
      />

      <AVTouchableOpacity
        onPress={onScanQr}
        style={[styles.iconButton, {right: 80}]}
        accessibilityLabel={Localized.Buttons.scan}
        accessible
        testID="qa_Checkout.Scan_btn"
      >
        <QRIconSVG color={Styles.Colors.Canteen.primary} />
      </AVTouchableOpacity>

      <AVTouchableOpacity
        onPress={onApply}
        style={[styles.applyButton, {right: Styles.Spacing.m3}]}
        accessibilityLabel={Localized.Buttons.apply}
        accessible
        testID="qa_Checkout.Apply_btn"
      >
        <AVText style={styles.applyText}>{Localized.Buttons.apply}</AVText>
        <View style={styles.underLine} />
      </AVTouchableOpacity>
    </View>

    {showError && errorMsg ? (
      <AVText style={[styles.errorText, errorTextStyle]}>{errorMsg}</AVText>
    ) : null}
  </View>
);

const styles = StyleSheet.create({
  container: {
    marginVertical: Styles.Spacing.m2,
  },
  inputWrapper: {
    position: 'relative',
  },
  input: {
    backgroundColor: Styles.white,
    paddingRight: 120,
  },
  outlineStyle: {
    borderRadius: 8,
  },
  shadowStyle: {
    zIndex: -9,
    ...getLayoutDescriber().shadowStyles().lightShadow,
  },
  contentStyle: {
    paddingTop: 0,
    paddingBottom: 0,
  },

  iconButton: {
    position: 'absolute',
    height: '100%',
    justifyContent: 'center',
    paddingTop: Styles.Spacing.m1,
  },
  applyButton: {
    position: 'absolute',
    height: '100%',
    justifyContent: 'center',
    paddingHorizontal: Styles.Spacing.m1,
    paddingTop: Styles.Spacing.m1,
  },
  applyText: {
    color: Styles.Colors.Canteen.primary,
    fontSize: Styles.Fonts.f0,
    fontWeight: '400',
    lineHeight: 20,
  },
  errorText: {
    color: Styles.dangerColor,
    marginTop: Styles.Spacing.m1,
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: Styles.Fonts.f0,
    marginLeft: Styles.Spacing.m1,
    fontWeight: '400',
    alignSelf: 'flex-start',
  },
  underLine: {
    borderBottomColor: Styles.Colors.Canteen.primary,
    borderBottomWidth: 1,
    marginTop: -3,
  },
});

export default DiscountCodeInput;
